import React, { useState, useRef } from 'react';
import { Otsikko } from './Otsikko';

export function Sitsilaulut() {
  const [visible, setVisible] = useState(false);
  const titleRef = useRef();

  return (
    <div className="container vitsit">
      <div ref={titleRef}>
        <Otsikko visible={visible} setVisible={setVisible}>
          Sitsilaulusikermä
        </Otsikko>
      </div>

      <p>
        Tämän vuoden Waputtimessa ensi kertaa kuultavan uuden sitsilaulusikermän
        sanat:
      </p>

      <h3>1. Hyvät ystävät</h3>
      <p>
        Hyvät ystävät, juhla voi alkaa,
        <br />
        sankarille me nostamme maljaa.
        <br />
        :,: Tääll' ei juodakaan kolmosen kaljaa,
        <br />
        meille viihdyn suo shamppanja vaan,
        <br />
        tralalaa! :,:
      </p>

      <h3>2. Nostakaamme malja</h3>
      <p>
        Nostakaamme malja,
        <br />
        Koskenkorvaa on!
        <br />
        {!visible ? (
          '...'
        ) : (
          <React.Fragment>
            {' '}
            Väljähtyköön kalja, mallas kelvoton!
            <br />
            Riemuella suo, siispä veikko juo,
            <br />
            riemuella suo, siis sä veikko juo!
          </React.Fragment>
        )}
      </p>
      {!visible && (
        <p className="lisaa">
          <button onClick={(e) => setVisible(true)} className="text-button">
            Lue lisää...
          </button>
        </p>
      )}

      {visible && (
        <React.Fragment>
          <h3>3. Helan går</h3>
          <p>
            Helan går, sjung
            <br />
            hopp-fa-de-ral-lan-lal-lan-lej!
            <br />
            Helan går, sjung
            <br />
            hopp-fa-de-ral-lan-lej!
            <br />
            Och den som inte helan tar,
            <br />
            han ej heller halvan får.
            <br />
            Helan går, sjung
            <br />
            hopp-fa-de-ral-lan-lej!
          </p>

          <h3>4. Unkarin viini</h3>
          <p>
            Voi, hyvät ystävät, meillä jos ois
            <br />
            Unkarin viiniä saavi!
            <br />
            Eikä kun kaks' sitä kantais ja jois,
            <br />
            paksusti voitais kuin paavi!
            <br />
            Silloinpa, veikko, ei huolt' olis lain,
            <br />
            saavissa kieli kun maattaisiin vain.
            <br />
            Voi, hyvät ystävät, meillä jos ois
            <br />
            Unkarin viiniä saavi!
          </p>

          <h3>5. Trink, trink, Brüderlein trink</h3>
          <p>
            Trink, trink, Brüderlein trink,
            <br />
            lass doch die Sorgen zu Haus.
            <br />
            Trink, trink, Brüderlein trink,
            <br />
            leere dein Glas mit mir aus.
            <br />
            Meide den Kummer und
            <br />
            meide den Schmerz,
            <br />
            dann ist das Leben ein Schertz.
            <br />
            Du lieber Augustin!
            <br />
            Kauf dir ein Auto und fahr gegen Baum,
            <br />
            dann ist das Leben ein Traum.
          </p>

          <h3>6. PO-hymni</h3>
          <p>
            Illalla ryyppään hilpeenä kaljaa!
            <br />
            Päivänvalo koittaa, ja pääsen kotio.
            <br />
            Aamulla koisaan kalpeena hiljaa!
            <br />
            Päivänvalo koittaa, ja pääsen kotio.
            <br />
            :,: Peeeooo, Peeeeeoo!
            <br />
            Päivänvalo koittaa, ja pääsen kotio. :,:
          </p>

          <h3>7. Aqua vera</h3>
          <p>
            Lauletaanpas vedestä,
            <br />
            jota aina riittää.
            <br />
            Vaikka kuinka joisit sä,
            <br />
            ei se lopu siitä.
            <br />
            Pikku Aqun jano on,
            <br />
            niin myös Paulin, Anteron.
            <br />
            Ah, kun sentään hyvältä
            <br />
            paljas vesi maistuu.
            <br />
            :,: Oooch vatten och vatten
            <br />
            och vatten är så gott,
            <br />
            så rysligt, fasligt, billigt,
            <br />
            så hälsosamt och vått. :,:
            <br />
            1, 2, 3 - VATTEN!
          </p>

          <h3>8. Benedictiner</h3>
          <p>:,: Benedictiner, Benedictiner Munklikör. :,: x 3</p>

          <h3>9. Ko-ko-ko-koskenkorvaa</h3>
          <p>
            Ko-ko-ko-koskenko-ko-ko-korvaa,
            <br />
            siitä aina kunnon räkä-kä-kä-kännit saa.
            <br />
            Ko-ko-ko-koskenko-ko-ko-korvaa,
            <br />
            siitä aina kunnon räkä-kä-kä-kännit,
            <br />
            aina kunnon räkä-kä-kä-kännit,
            <br />
            aina kunnon räkä-kä-kä-kännit saa!
          </p>

          <h3>10. Hei vahtimestari</h3>
          <p>
            :,: Hei, vahtimestari tule täytä lasini,
            <br />
            vie tyhjät pullot pois. :,:
            <br />
            :,: Kyllä enemmänkin juodaan,
            <br />
            jos vain lisää tuodaan,
            <br />
            ja laskut maksetaan,
            <br />
            jos jaksetaan. :,:
          </p>

          <h3>11. Ikuisen teekkarin laulu</h3>
          <p>
            Talvi-iltain tummentuessa
            <br />
            Polin suojiin me saavumme taas.
            <br />
            :,: Meidät tekniikka jälkeen on jättänyt,
            <br />
            sen me tahdomme unhoittaa. :,:
            <br />
          </p>

          <p className="lisaa">
            <button
              onClick={(e) => {
                setVisible(false);
                if (titleRef) {
                  titleRef.current.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="text-button"
            >
              Lue vähemmän...
            </button>
          </p>
        </React.Fragment>
      )}
    </div>
  );
}
